export default "__VITE_ASSET__CyMvJKAv__"